import { log } from '@/log'
import { sortByDisplayLevel } from '@/models/api/display-level'
import _ from 'lodash'

interface Item {
  tags: ItemTag[]
  display_level: number
}
interface ItemTag {
  pathname: string
  name: string
}

export function sortProductclassForColorStock(items: Item[], selectedColor: string | undefined): Item[] {
  try {
    return items.sort((before, after) => {
      const beforeColor = _.find(before.tags, tag => /^company\.product\.color\./.test(tag.pathname))
      const afterColor = _.find(after.tags, tag => /^company\.product\.color\./.test(tag.pathname))

      const beforeColorName = beforeColor ? beforeColor.name : null
      const afterColorName = afterColor ? afterColor.name : null

      if (selectedColor) {
        if (beforeColor && beforeColorName === selectedColor) return -1
        if (afterColor && afterColorName === selectedColor) return 1
      }

      return sortByDisplayLevel.asc.compare(before, after)
    })

  } catch (error) {
    log.error(error)

    return []
  }
}
